<template>
  <edit-dialog
    headline-text="Add Hedge"
    :value="value"
    :show-decline="false"
    accept-text="close"
    @input="$emit('input', $event)"
  >
    <p>
      Showing hedges that appeared on the lot.
    </p>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="allocations"
    >
      <template v-slot:item.use="{ item }">
        <v-btn
          color="primary"
          x-small
          text
          @click="selectAllocation(item)"
        >
          select
        </v-btn>
      </template>
    </v-data-table>
  </edit-dialog>
</template>

<script>
import { fetchLotAllocations } from '../../../requests/lot'

export default {
  name: 'AddFromAllocations',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    lotId: {
      type: [Number, String],
      required: true
    }
  },
  watch: {
    async value (opened) {
      if (!opened) return
      if (this.allocations.length === 0) {
        this.loading = true
      }
      await this.initialize()
      this.loading = false
    }
  },
  data: () => ({
    loading: true,
    allocations: [],
    headers: [
      { text: 'hedge id', value: 'hedge.id' },
      { text: 'code', value: 'hedge.code' },
      { text: 'Pt Toz', value: 'pt' },
      { text: 'Pd Toz', value: 'pd' },
      { text: 'Rh Toz', value: 'rh' },
      { text: 'Pt Rate', value: 'hedge.pt_rate_per_toz' },
      { text: 'Pd Rate', value: 'hedge.pd_rate_per_toz' },
      { text: 'Rh Rate', value: 'hedge.rh_rate_per_toz' },
      { text: 'Use', value: 'use' }
    ]
  }),
  methods: {
    selectAllocation (allocation) {
      this.$emit('addHedge', {
        id: allocation.hedge.id,
        ptAvailableToz: allocation.pt,
        ptRate: allocation.hedge.pt_rate_per_toz_fx,
        pdAvailableToz: allocation.pd,
        pdRate: allocation.hedge.pd_rate_per_toz_fx,
        rhAvailableToz: allocation.rh,
        rhRate: allocation.hedge.rh_rate_per_toz_fx
      })
    },
    async initialize () {
      const response = await fetchLotAllocations(this.lotId)
      if (response.data && response.data.allocations) {
        this.allocations = response.data.allocations.filter(alloc => alloc.status !== 'HIS')
      }
    }
  }
}
</script>
